export class EventEmitter {
  private listeners: Record<string, Array<(...args: any) => any>>
  constructor() {
    this.listeners = {}
  }

  emit(event: string, ...args: any) {
    const listeners = this.listeners[event]
    if (!listeners || !listeners.length) {
      return;
    }
    for (const listener of listeners) {
      try {
        listener(...args)
      } catch (e) {
        console.warn('error', event, e)
      }
    }
    for (const listener of listeners) {
      if ((listener as any).once) {
        this.off(event, listener)
      }
    }
  }

  once(event: string, listener: (...args: any) => any) {
    return this._on(event, listener, true)
  }

  on(event: string, listener: (...args: any) => any) {
    return this._on(event, listener);
  }

  private _on(event: string, listener: (...args: any) => any, once?: boolean) {
    const listeners = this.listeners[event] || []
    const index = listeners.indexOf(listener)
    if (index === -1) {
      listeners.push(listener)
    }
    this.listeners[event] = listeners;
    (listener as any).once = !!once;
    const remove = () => this.off(event, listener)
    return { remove }
  }

  off(event?: string, listener?: (...args: any) => any) {
    if (!event) {
      for (const key in this.listeners) {
        this.listeners[key].length = 0
        delete this.listeners[key]
      }
      return
    }
    if (!listener) {
      delete this.listeners[event]
    }
    const listeners = this.listeners[event]
    if (!listeners) {
      return;
    }
    const index = listeners.indexOf(listener as any)
    if (index !== -1) {
      listeners.splice(index, 1)
    }
    if (!listeners.length) {
      delete this.listeners[event]
    }
  }
}